import React, { ReactNode, useState, useEffect } from 'react';

// Material ui
import { Grid, IconButton } from '@material-ui/core';

// Components
import Divider from '@components/UI-KIT/Divider';

// Icons
import { ChevronBigLeft, ChevronBigRight } from '@/assets/icons';

// Style
import VARIABLES from '@/assets/variables';
import './CarouselIndicators.scss';

interface Props {
    carouselPages: any;
    carousel: any;
}

const CarouselIndicators: React.FC<Props> = ({
    carousel,
    carouselPages
}) => {
    const [ disabledState, _setDisabledState ] = useState({
        buttonNext: false,
        buttonPrev: false
    });
    const [ activePage, setActivePage ] = useState(0);
    const [ accountScroll, setAccountScroll ] = useState<ReactNode[]>([]);
    const [ { width, left }, setStyles ] = useState({
        width: '',
        left: ''
    });

    useEffect(() => {
        setAccountScroll(new Array(carouselPages.current)
            .fill(<Divider />)
            .map((divider: ReactNode, index: number) => (
                <Grid
                    key={`divider-${index + 1}`}
                    style={{ width: `calc(100% / ${carouselPages.current})` }}
                    className="ui-Scroll-pagination-bar-container"
                >
                    { divider }
                </Grid>
            )));
        setStyles({
            width: `calc(100% / ${carouselPages.current})`,
            left: `${activePage * (100 / carouselPages.current)}%`
        });
    }, [ carouselPages.current, activePage ]);

    return (
        <Grid
            container
            wrap="nowrap"
            spacing={3}
        >
            <Grid
                item
                xs={11}
                container
                className="ui-Scroll-pagination-container"
                alignItems="center"
                wrap="nowrap"
            >
                {accountScroll}
                { carouselPages.current > 1 && (
                    <Grid
                        className="ui-Current-page"
                        style={{
                            width,
                            left
                        }}
                    >
                        <Divider
                            className="ui-Current-page-indicator"
                        />
                    </Grid>
                )}
            </Grid>
            <Grid
                item
                container
                justify="space-between"
                xs={1}
                className="ui-Scroll-pagination-buttons-container"
            >
                <IconButton
                    disableRipple
                    className="ui-Scroll-pagination-button"
                    disabled={disabledState.buttonPrev}
                    onClick={() => {
                        carousel.current.slidePrev();
                        if (activePage !== 0)
                            setActivePage(prevState => prevState - 1);
                    }}
                >
                    <ChevronBigLeft
                        color={disabledState.buttonPrev ? VARIABLES.palette.secondary_light : VARIABLES.palette.secondary_color}
                    />
                </IconButton>
                <IconButton
                    disableRipple
                    className="ui-Scroll-pagination-button"
                    disabled={disabledState.buttonNext}
                    onClick={() => {
                        carousel.current.slideNext();
                        if (activePage !== carouselPages.current - 1)
                            setActivePage(prevState => prevState + 1);
                    }}
                >
                    <ChevronBigRight
                        color={disabledState.buttonNext ? VARIABLES.palette.secondary_light : VARIABLES.palette.secondary_color}
                    />
                </IconButton>
            </Grid>
        </Grid>
    );
};

export default CarouselIndicators;